export default __webpack_public_path__ + "static/media/product9.343d8b7d.webp";